/**
 * Правление — копия legacy main_managers.tpl: центрированная колонка
 * (col-md-offset-4 col-md-5) с таблицей «ФИО + (должность)» слева и
 * «тел.: / mail:» справа, разделитель — border-bottom у строки.
 *
 * NULL в БД в PHP сравнивался с '' как пустая строка — повторяем через ?? ''.
 */

import { useApi } from '@/lib/useApi'

/** Строка таблицы managers. */
interface Manager {
  id: number
  name: string | null
  position: string | null
  phone: string | null
  email: string | null
}

export function ManagersPage() {
  const { data } = useApi<Manager[]>('/api/content/managers')
  const managers = data ?? []

  return (
    <div className="row">
      <div className="col-xs-12 col-md-offset-4 col-md-5">
        <div style={{ paddingTop: '20px' }}>
          <table>
            <tbody>
              {managers.map((manager) => {
                const name = manager.name ?? ''
                const position = manager.position ?? ''
                const phone = manager.phone ?? ''
                const email = manager.email ?? ''

                return (
                  <tr key={manager.id} style={{ borderBottom: '1px solid #ddd' }}>
                    <td>
                      {name !== '' && (
                        <div className="man_name">
                          <div className="body">{name}</div>
                        </div>
                      )}
                      {position !== '' && (
                        <div className="man_position">
                          <div className="body">({position})</div>
                        </div>
                      )}
                    </td>
                    <td>
                      <div className="man_phone">
                        <div className="body">тел.: {phone === '' ? 'нет' : phone}</div>
                      </div>

                      <div className="man_email">
                        <div className="body">mail: {email === '' ? 'нет' : email}</div>
                      </div>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
